import { useCallback } from 'react';

import ENV from 'react-native-config';

import { AxiosResponse } from 'axios';

import { getContentTokenUrl } from 'config/api';

import NagraInstance from 'utils/axios/nagra/DefaultInstance';

type DrmTokenResponse = AxiosResponse<{
    refresh_token: string;
    access_token: string;
    content_token: string;
    token_type: string;
    expires_in: number;
}>;

function useGetDrmContentToken() {
    return useCallback(async (drmId: string): Promise<string> => {
        const response: DrmTokenResponse = await NagraInstance.post(
            getContentTokenUrl(drmId),
            undefined,
            {
                headers: {
                    'nv-tenant-id': ENV.TENANT_ID,
                },
            },
        );

        return response.data.content_token;
    }, []);
}

export default useGetDrmContentToken;
